import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'about',
  footer: 'future-friendly',
}

const pageBrand: PageBrand = 'corporate'

export const futureFriendly = new LineOfBusinessConfig(geConfig, pageBrand)
